import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { AlternateLanguage, PageContextType } from 'types';
import { CookieConsent } from 'components/CookieConsent';
import { MainFooter } from 'components/MainFooter';
import { MainNavigation } from 'components/MainNavigation';
import './Layout.scss';

type LayoutProps = {
    children: any;
    lang: string;
    homePage: string | null;
    pageContext: PageContextType;
    alternateLanguages: AlternateLanguage[];
    hasGivenCookieConsent: boolean;
    handleCookieConsent: () => void;
    options: {
        show_navigation_header: boolean;
        show_footer: boolean;
    };
};

export const getDataForLang = (all: any, lang: string) => {
    if (!all || !all.edges || !all.edges.length) {
        return undefined;
    }

    const findEdge = (language: string) => {
        return all.edges.find((e: any) => e.node.lang === language);
    };

    const edge = findEdge(lang) || findEdge('en-us') || {};

    return edge.node && edge.node.data;
};

type LayoutData = {
    allPrismicMainFooter: any;
    allPrismicMainNavigation: any;
    allPrismicCookieConsent: any;
};

export default ({
    children,
    lang,
    alternateLanguages,
    options,
    pageContext,
    homePage,
    hasGivenCookieConsent,
    handleCookieConsent,
}: LayoutProps) => (
    <StaticQuery
        query={graphql`
            query LayoutQuery {
                allPrismicMainNavigation {
                    edges {
                        node {
                            lang
                            ...PrismicMainNavigationFragment
                        }
                    }
                }
                allPrismicMainFooter {
                    edges {
                        node {
                            lang
                            ...PrismicMainFooterFragment
                        }
                    }
                }
                allPrismicCookieConsent {
                    edges {
                        node {
                            lang
                            ...PrismicCookieConsentFragment
                        }
                    }
                }
            }
        `}
        render={(data: LayoutData) => (
            <div className="Site">
                {options.show_navigation_header && (
                    <MainNavigation
                        mainNavigationData={getDataForLang(
                            data.allPrismicMainNavigation,
                            pageContext.lang,
                        )}
                        pageContext={pageContext}
                        homePage={homePage}
                    />
                )}
                <div className="Site-body">{children}</div>
                {options.show_footer && (
                    <MainFooter
                        mainFooterData={getDataForLang(data.allPrismicMainFooter, pageContext.lang)}
                        alternateLanguages={alternateLanguages}
                        lang={lang}
                    />
                )}
                {!hasGivenCookieConsent && (
                    <CookieConsent
                        handleCookieConsent={handleCookieConsent}
                        {...getDataForLang(data.allPrismicCookieConsent, pageContext.lang)}
                    />
                )}
            </div>
        )}
    />
);

export const LayoutFragments = graphql`
    # This fragment is used by most images in the app
    fragment ChildImageSharpFragment on File {
        childImageSharp {
            sizes(maxWidth: 1920, quality: 85) {
                ...GatsbyImageSharpSizes
            }
        }
    }
`;
